module.exports = __webpack_public_path__ + "img/2178.5c901f26.gif";